import LinearProgress from "@material-ui/core/LinearProgress";
import { Toolbar } from "@devexpress/dx-react-scheduler-material-ui";

export const ToolbarWithLoading = (data: any) => {
  const { children, ...restProps } = data;
  return (
    <div className="scheduler-toolbar-root-with-loading">
      <Toolbar.Root {...restProps}> {children} </Toolbar.Root>
      <LinearProgress className="scheduler-toolbar-root-with-loading-progress" />
    </div>
  );
};
